import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { JornalService } from 'src/app/services/jornal.service';
import { obterEdicaoPorData, obterEdicaoPorDataFailure, obterEdicaoPorDataSuccess } from '../../actions/Jornal/obter-edicao-por-data-publicacao.action';

@Injectable()
export class ObterEdicaoPorDataEffects {

  public obterEdicaoPorData$: unknown;

  constructor(private actions$: Actions,
    private jornalService: JornalService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterEdicaoPorData$ = createEffect(() => this.actions$.pipe(
      ofType(obterEdicaoPorData),
      switchMap(({ inputDto }) =>
        this.jornalService
          .ObterEdicaoPorDataPublicacao(inputDto)
          .pipe(
            map(
              response => {
                if (response.erros != undefined && response.erros.length > 0) {
                  return obterEdicaoPorDataFailure({ response })
                }
                return obterEdicaoPorDataSuccess({ response })
              }),
            catchError(() => {
              return of()
            }
            )
          )
      )
    )
    );
  }
}
